var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 80,
    viewBox: "0 0 61 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1667 0L0.5 0L0.5 80L60.5 80L60.5 26.6667L37.1667 26.6667L37.1667 0ZM10.5 36.9697C10.5 34.9614 12.1281 33.3333 14.1364 33.3333L46.8636 33.3333C48.8719 33.3333 50.5 34.9614 50.5 36.9697L50.5 69.697C50.5 71.7053 48.8719 73.3333 46.8636 73.3333L14.1364 73.3333C12.1281 73.3333 10.5 71.7053 10.5 69.697L10.5 36.9697ZM17.1667 40C17.1667 38.7727 18.1616 37.7778 19.3889 37.7778L41.6111 37.7778C42.8384 37.7778 43.8333 38.7727 43.8333 40V66.6667C43.8333 67.894 42.8384 68.8889 41.6111 68.8889H19.3889C18.1616 68.8889 17.1667 67.894 17.1667 66.6667V64.4444H19.3889V65.5556C19.3889 66.1692 19.8864 66.6667 20.5 66.6667H40.5C41.1137 66.6667 41.6111 66.1692 41.6111 65.5556V41.1111C41.6111 40.4975 41.1137 40 40.5 40L20.5 40C19.8863 40 19.3889 40.4975 19.3889 41.1111V42.2222H17.1667V40ZM23.8333 55.5556L23.8333 62.2222L32.7222 53.3333L23.8333 44.4444V51.1111L12.7222 51.1111V55.5556L23.8333 55.5556ZM50.5 13.3333L40.5 3.33333L40.5 23.3333L60.5 23.3333L50.5 13.3333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportSummary);
export default __webpack_public_path__ + "static/media/ImportSummary.51f068790601647b2a64e9455e1c6a04.svg";
export { ForwardRef as ReactComponent };